<template>
  <div class="editor">
    <MutiImgUpload
      ref="imgs"
      :mainImgNums="0"
      :limitWidth="[480, 1500]"
      :limitHeight="[0, 2000]"
      :limitNums="20"
      :size="200"
      :imgs="alibabaForm[key]"
      limitSuffix=".jpg,.jpeg,.png"
      @change="onChange"
    />
    <div class="tips ft-12">
      <span style="display: block">1. 新版详情已将PC、无线详情合二为一，仅支持图片格式</span>
      <span style="display: block">2. 图片类型支持png、jpg、jpeg，要求单个图片的原图宽度为480px~1500px，高度≤2000px。</span>
    </div>
  </div>
</template>

<script>
// 新版的淘宝平台无限详情不走富文本，全用图片，所以改为图片上传组件
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import storeMixins from '../store-mixins';
export default {
  mixins: [storeMixins],
  components: {
    MutiImgUpload,
  },
  props: ['props'],
  computed: {
    key() {
      if (this.isWirelessDesc) {
        return 'newWirelessDesc';
      }
      return this.props.name;
    },
    isWirelessDesc() {
      return this.props.name === 'wirelessDesc';
    },
  },
  methods: {
    onChange(v) {
      const newFormFields = {};
      newFormFields[this.key] = v;
      this.updateAlibabaForm(newFormFields);
    },
  },
  mounted() {
    this.$parent.$parent.rules.push({
      required: true,
      validator: (rule, value, cb) => {
        let _value = this.alibabaForm[this.key];
        if (!_value || !_value.length) {
          return cb(new Error('必填'));
        }
        cb();
      },
    });
    this.$parent.$parent.rules.push({
      validator: async (rule, value, callback) => {
        let errMsg = await this.$refs.imgs.method_validImage();
        if (errMsg) {
          callback(new Error(errMsg));
        } else {
          callback();
        }
      },
    });
  },
};
</script>

<style lang="scss">
#editor-wirelessDesc {
  .w-e-text {
    text-align: center;
    img {
      display: block;
      margin: 0 auto;
    }
  }
}
</style>